/**
 * 每日启动器 Logo — minimal rotating clock (2026-05-18).
 *
 * A rounded-square frame, a cyan dial center, an amber hour hand pointing roughly
 * to "5". The hand rotates clockwise (1 full revolution per minute) — references the
 * 5-minute rhythm without explicit "5" digits or G5 letters (visual taboo per spec).
 *
 * The rotation lives in CSS (.logo-clock-hand) so it pauses with prefers-reduced-motion.
 */
interface LogoMarkProps {
  size?: number;
  title?: string;
}

export function LogoMark({ size = 40, title = '每日启动器' }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className="logo-clock"
    >
      {/* Outer rounded-square frame */}
      <rect
        x="4"
        y="4"
        width="56"
        height="56"
        rx="12"
        fill="#FDFDF9"
        stroke="#111111"
        strokeWidth="4"
      />
      {/* Inner clock face */}
      <circle cx="32" cy="32" r="18" fill="#FDFDF9" stroke="#111111" strokeWidth="2.5" />
      {/* Tick marks at 12 / 3 / 6 / 9 — calm, not full 12-tick */}
      <line x1="32" y1="16" x2="32" y2="19" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
      <line x1="48" y1="32" x2="45" y2="32" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
      <line x1="32" y1="48" x2="32" y2="45" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="32" x2="19" y2="32" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
      {/* Clockwise-rotating hand. Origin (32,32), points up by default (to "12"). */}
      <g className="logo-clock-hand" style={{ transformOrigin: '32px 32px' }}>
        <line
          x1="32"
          y1="32"
          x2="32"
          y2="20"
          stroke="#25C7D2"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </g>
      {/* Center pivot */}
      <circle cx="32" cy="32" r="2.5" fill="#111111" />
    </svg>
  );
}
